import { Navigate } from 'react-router-dom';
import { GuardProps } from '@/types';
import { useAppSelector } from '@/hooks/useAppSelector';
import Loader from '@/ui-component/Loader';
import { getUserHomePath, isSupervisor, isSilverStayUser } from '@/utils/role';

const SupervisorGuard = ({ children, onlyHospitalOrganization = false }: GuardProps) => {
    const { isInitializing } = useAppSelector(({ auth }) => auth);
    const { profile } = useAppSelector((state) => state.profile);

    if (isInitializing) {
        return <Loader />;
    }
    const isUserSupervisor = isSupervisor(profile);
    const canAccess = onlyHospitalOrganization ? isUserSupervisor && !isSilverStayUser(profile) : isUserSupervisor;
    if (!canAccess) {
        return <Navigate to={getUserHomePath(profile)} replace />;
    }

    return children;
};

export default SupervisorGuard;
